import CustomIcon from "./CustomIcon";
import {CustomSpinner} from "./CustomSpinner";

const ChipGroup = ({
                     children,
                     className
                   }) => {
  return (
    <div className={`flex flex-wrap${className ? ` ${className}` : " mb-5"}`}>
      {children}
    </div>
  );
};


export const ChipSecondary = ({
                                label, leading, onClose, disabled = false, backgroundColor, onClick, loading
                              }) => {
  return (
    <div onClick={onClick}
         className={`rounded border p-1.5 text-dark text-sm flex space-x-1.5 items-center mr-1 mb-1 ${backgroundColor ? backgroundColor : "bg-neutral"}`}>
      {!!leading && leading}
      <span>{label}</span>
      {loading ? <CustomSpinner size="h-3 w-3"/> : !!onClose ? <div
        className={`rounded bg-neutral flex items-center p-1 text-dark ${disabled ? 'text-gray-500 cursor-not-allowed' : 'hover:text-error-100 cursor-pointer'}`}
        onClick={disabled ? null : onClose}><CustomIcon icon="close" size="sm"
      /></div> : ""}

    </div>
  );
};

export default ChipGroup;